import { useEffect, useState } from "react";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import LazyLoad from "react-lazyload";
import { getPrincipalMessage } from "../Service/Api";

const PrincipalMessage = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      setData(messages);
    };
    fetchData();
  }, []);

  const emptyArray = [];

  const homeMenu = [
    { label: "Vision", link: "/about" },
    {
      label: "Management",
      link: "",
      subMenu: [
        { label: "Director-Principal's Message", link: "/PrincipalMessage" },
        { label: "Leadership Team", link: "/leadershipTeam" },
        { label: "Patron’s Message", link: "/patrons" },
        { label: "Advisory Board", link: "/advisoryBoard" },
      ],
    },
    { label: "International Collaborations", link: "/partnership" },
    // { label: "Awards & Achievements", link: "/awardsAcheivements" },

{
      label: "Awards & Achievements",
      link: "/awardsAcheivements",
      subMenu: [
        { label: "Accolades & Achievements", link: "/awardsAcheivements" },
        { label: "Students Achievements", link: "/studentsAcheivements" },
      ],
    },

    { label: "Faculty", link: "/faculty" },
    { label: "Staff Details", link: "/staffDetails" },
    { label: "School Strength ", link: "/schoolStrength" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
  ];

  const vicePrincipalMessages = data.filter(
    (item) => item.category === "Vice Principal",
  );

  // Find Ruchi's message and separate the rest
  const ruchiMessage = vicePrincipalMessages.find(
    (msg) => msg.name === "MRS RUCHI JOSHI"
,
  );
  const otherMessages = vicePrincipalMessages.filter(
    (msg) => msg.name !== "MRS RUCHI JOSHI",
  );

 return (
  <>
    <Header />

    <Breadcrumb
      breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-about-4.jpg"
    />

    <Menu MenuItem={homeMenu} />

    <div className="padding-blk inner-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <PageTitle
              pageTitle="Leadership Board"
              breadEnd="Leadership Board"
              breadMid="Leadership Board"
            />
          </div>
        </div>

        {/* Ruchi's Message */}
        {ruchiMessage && (
          <>
            <div className="row mt-4">
              <div className="col-md-12">
                <h4 className="color-red">
                  VICE PRINCIPAL 
                </h4>
              </div>
            </div>

            <div className="row justify-content-center mt-4">
              <div className="col-md-12">
                <div className="wt-team-1">
                  <div className="wt-media">
                    <LazyLoad>
                      <img
                        src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${ruchiMessage.attachments?.[0]}`}
                        alt={ruchiMessage.name}
                        className="img-fluid"
                      />
                    </LazyLoad>
                  </div>
                </div>

                <h5 className="color-green">
                  {ruchiMessage.name}
                </h5>

                <p
                  className="custom-message"
                  dangerouslySetInnerHTML={{
                    __html: ruchiMessage.message,
                  }}
                />
              </div>
            </div>
          </>
        )}

        {/* Other Vice Principal Messages */}
        {otherMessages.length > 0 && (
          <>
            <div className="row mt-5">
              <div className="col-md-12">
                <h4 className="color-red">
                  VICE PRINCIPAL (SENIOR WING)
                </h4>
              </div>
            </div>

            {otherMessages.map((item, index) => (
              <div
                className="row justify-content-center mt-4"
                key={item.id || item.name || index}
              >
                <div className="col-md-12">
                  <div className="wt-team-1">
                    <div className="wt-media">
                      <LazyLoad>
                        <img
                          src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments?.[0]}`}
                          alt={item.name}
                          className="img-fluid"
                        />
                      </LazyLoad>
                    </div>
                  </div>

                  <h5 className="color-green">
                    {item.name}
                  </h5>

                  <p
                    className="custom-message"
                    dangerouslySetInnerHTML={{
                      __html: item.message,
                    }}
                  />
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>

    <Footer />
  </>
);
};

export default PrincipalMessage